import { request } from './client';

export const apiGetAddresses = () => request('/users/addresses');

export const apiAddAddress = (address) =>
  request('/users/addresses', { method: 'POST', body: address });

export const apiUpdateAddress = (id, data) =>
  request(`/users/addresses/${id}`, { method: 'PUT', body: data });

export const apiDeleteAddress = (id) =>
  request(`/users/addresses/${id}`, { method: 'DELETE' });

export const apiSetDefaultAddress = (id) =>
  request(`/users/addresses/${id}/default`, { method: 'PUT' });
